export default function ClaimsTypes() {
  const claims = [
    {
      title: 'Water Damage & Plumbing Leaks',
      icon: 'ri-drop-line',
      image: 'https://public.readdy.ai/ai/img_res/b26343f921e8e7369cc093927859d591.jpg'
    },
    {
      title: 'Fire & Smoke Damage',
      icon: 'ri-fire-line',
      image: 'https://readdy.ai/api/search-image?query=fire%20and%20smoke%20damage%20in%20residential%20property%20interior%20with%20charred%20walls%20and%20smoke%20stains%2C%20professional%20insurance%20claim%20documentation%20photography%2C%20realistic%20fire%20damage%20assessment%20scene%2C%20dramatic%20lighting%20showing%20extent%20of%20damage%2C%20simple%20clean%20background%20emphasizing%20the%20fire%20damage&width=400&height=400&seq=claim-fire-001&orientation=squarish'
    },
    {
      title: 'Storm, Wind & Roof Damage',
      icon: 'ri-windy-line',
      image: 'https://readdy.ai/api/search-image?query=storm%20and%20wind%20damage%20to%20residential%20roof%20with%20missing%20shingles%20and%20structural%20damage%2C%20professional%20insurance%20documentation%20photography%20from%20ground%20level%2C%20realistic%20weather%20damage%20assessment%20scene%2C%20clear%20daylight%20showing%20roof%20damage%20details%2C%20simple%20sky%20background&width=400&height=400&seq=claim-storm-001&orientation=squarish'
    },
    {
      title: 'Mold',
      icon: 'ri-contrast-drop-line',
      image: 'https://readdy.ai/api/search-image?query=mold%20growth%20and%20contamination%20on%20residential%20property%20walls%20and%20surfaces%2C%20professional%20insurance%20claim%20documentation%20photography%2C%20realistic%20mold%20damage%20assessment%20scene%2C%20neutral%20lighting%20showing%20mold%20patterns%20clearly%2C%20simple%20clean%20background%20focusing%20on%20mold%20damage%20area&width=400&height=400&seq=claim-mold-001&orientation=squarish'
    },
    {
      title: 'Vandalism & Theft',
      icon: 'ri-shield-cross-line',
      image: 'https://readdy.ai/api/search-image?query=vandalism%20and%20theft%20damage%20to%20commercial%20property%20with%20broken%20windows%20and%20damaged%20entry%2C%20professional%20insurance%20documentation%20photography%2C%20realistic%20property%20damage%20assessment%20scene%2C%20clear%20lighting%20showing%20vandalism%20details%2C%20simple%20urban%20background&width=400&height=400&seq=claim-vandal-001&orientation=squarish'
    },
    {
      title: 'Structural Issues',
      icon: 'ri-home-gear-line',
      image: 'https://readdy.ai/api/search-image?query=structural%20damage%20and%20foundation%20issues%20in%20residential%20property%20with%20visible%20cracks%20in%20walls%20and%20ceiling%2C%20professional%20insurance%20claim%20documentation%20photography%2C%20realistic%20structural%20damage%20assessment%20scene%2C%20neutral%20lighting%20highlighting%20structural%20problems%2C%20simple%20clean%20background&width=400&height=400&seq=claim-struct-001&orientation=squarish'
    },
    {
      title: 'Business Interruption',
      icon: 'ri-store-3-line',
      image: 'https://readdy.ai/api/search-image?query=closed%20business%20storefront%20with%20damage%20requiring%20business%20interruption%20claim%2C%20professional%20insurance%20documentation%20photography%2C%20realistic%20commercial%20property%20damage%20scene%2C%20clear%20daylight%20showing%20closed%20business%2C%20simple%20urban%20street%20background&width=400&height=400&seq=claim-business-001&orientation=squarish'
    },
    {
      title: 'Other Property Losses',
      icon: 'ri-home-line',
      image: 'https://readdy.ai/api/search-image?query=general%20property%20damage%20requiring%20insurance%20claim%20with%20various%20types%20of%20damage%20visible%2C%20professional%20insurance%20documentation%20photography%2C%20realistic%20property%20damage%20assessment%20scene%2C%20neutral%20lighting%20showing%20damage%20details%2C%20simple%20clean%20background%20focusing%20on%20property%20damage&width=400&height=400&seq=claim-other-001&orientation=squarish'
    }
  ];

  return (
    <section id="claims" className="py-20 bg-[#1e3a5f]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-white mb-4">Types of Claims We Handle</h2>
          <div className="w-16 h-1 bg-[#FF6B35] mx-auto"></div>
          <p className="text-lg text-white/80 mt-6 max-w-3xl mx-auto">
            No two claims are alike. No two adjusters approach a loss the same way. Our job is to uncover every detail and ensure nothing is missed.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {claims.map((claim, index) => (
            <div
              key={index}
              className="relative rounded-xl overflow-hidden group cursor-pointer h-60"
            >
              <div className="absolute inset-0">
                <img
                  src={claim.image}
                  alt={claim.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent group-hover:from-black/90 transition-all"></div>
              </div>
              <div className="absolute inset-0 flex flex-col justify-end p-6">
                <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35] rounded-lg mb-3 opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className={`${claim.icon} text-xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-white">{claim.title}</h3>
                <div className="mt-3 opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="text-white text-sm font-semibold inline-flex items-center cursor-pointer">
                    View Details
                    <i className="ri-arrow-right-line ml-2"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
